export var ApiTokenScope;
(function (ApiTokenScope) {
    ApiTokenScope["READ"] = "read";
    ApiTokenScope["WRITE"] = "write";
})(ApiTokenScope || (ApiTokenScope = {}));
//# sourceMappingURL=apiToken.js.map